(function($) {
  $(document).ready(function() {
    var $form = $('.view-instructors form');
    var $results = $('.view-empty');

    if ($form.length && $results.length) {
      $form.addClass('empty-exposed-form');
      $('.view-instructors ').addClass('remove-pager');
    }
  });
})(jQuery);
